import { KeyboardSensor, useSensor, useSensors } from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';
import { SmartPointerSensor } from '../sensors/SmartPointerSensor.tsx';

/**
 * Sostituisce il default PointerSensor con uno SmartPointerSensor
 * che evita di iniziare il drag su elementi interattivi
 */
export function useSmartSensors() {
  const pointerSensor = useSensor(SmartPointerSensor, {
    activationConstraint: {
      distance: 8,
    },
  });
  const keyboardSensor = useSensor(KeyboardSensor, {
    coordinateGetter: sortableKeyboardCoordinates,
  });

  return useSensors(pointerSensor, keyboardSensor);
}
